import { render, staticRenderFns } from "./HomePageFour.vue?vue&type=template&id=56c88566&scoped=true&"
import script from "./HomePageFour.vue?vue&type=script&lang=ts&"
export * from "./HomePageFour.vue?vue&type=script&lang=ts&"
import style0 from "./HomePageFour.vue?vue&type=style&index=0&id=56c88566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c88566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VLayout,VRow})
